/** 鉴权状态工具 — 多用户 token 存 localStorage */
const TOKEN_KEY = 'fenxi_token'
const USER_KEY = 'fenxi_user'

export interface AuthUser {
  username: string
  role: string
  loginAt: number
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string, username: string, role: string = 'admin'): void {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(
    USER_KEY,
    JSON.stringify({ username, role, loginAt: Date.now() } satisfies AuthUser),
  )
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getUser(): AuthUser | null {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as AuthUser
  } catch {
    return null
  }
}

export function isAuthed(): boolean {
  return Boolean(getToken())
}
